import { showSuccess, showError } from '@/utils/toastHelpers';
import { useCreateSeries, useUpdateSeries, useDeleteSeries } from '@/hooks/useRaceSeries';
import { useEntityActions } from '@/hooks/useEntityActions';
import { RaceSeries, SeriesFormData } from './raceseriesmanager.props';

const emptyForm: SeriesFormData = { name: '', description: '', imageUrl: '' };

export const useRaceSeriesActions = () => {
  const createSeries = useCreateSeries();
  const updateSeries = useUpdateSeries();
  const deleteSeries = useDeleteSeries();

  const crud = useEntityActions<RaceSeries, SeriesFormData>({
    emptyForm,
    deleteMutation: deleteSeries,
    entityName: 'Серијата',
  });

  const openCreate = () => {
    crud.openCreate();
  };

  const openEdit = (series: RaceSeries) => {
    crud.openEdit(series, (s) => ({
      name: s.name, description: s.description || '', imageUrl: s.imageUrl || '',
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      if (crud.editingEntity) {
        await updateSeries.mutateAsync({ id: crud.editingEntity.id, data: crud.formData });
        showSuccess('Успешно', 'Серијата е ажурирана');
      } else {
        await createSeries.mutateAsync(crud.formData);
        showSuccess('Успешно', 'Серијата е креирана');
      }
      crud.resetDialog();
    } catch (error) {
      showError(error, 'серијата');
    }
  };

  return {
    isDialogOpen: crud.isDialogOpen, setIsDialogOpen: crud.setIsDialogOpen,
    editingSeries: crud.editingEntity, formData: crud.formData, setFormData: crud.setFormData,
    deleteTarget: crud.deleteTarget, setDeleteTarget: crud.setDeleteTarget,
    openCreate, openEdit,
    handleSubmit, handleDelete: crud.handleDelete, confirmDelete: crud.confirmDelete,
  };
};
